import { Injectable } from '@angular/core';
import { HeaderConfigService } from '@os-components';

@Injectable({
    providedIn: 'root',
})
export class DateService {
    public constructor(private configService: HeaderConfigService) {}

    public getDate(fsDate: any): string {
        const date = new Date(fsDate);
        const localization = this.configService.getLanguage().toUpperCase();
        const locale = localization.slice(0, localization.indexOf('_')).toLowerCase();

        return date.toLocaleString(locale, {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        });
    }
}
